<template>
    <text-element
        idKey="email"
        type="email"
        required
        autocomplete="email"
        v-model="email"
        @keyup.enter="enterHandler"
        placeholder="Email"
        :errors="errors || null"
    >
        <label
            for="email"
            class="text-sm font-medium won-label-text-color mb-2 block"
            v-if="showLabel"
        >
            Email
        </label>
    </text-element>
</template>

<script setup>
import TextElement from "../../forms/elements/text.vue";

const emit = defineEmits(['keyup:enter']);
const props = defineProps({
    errors: {
        type: String,
        default: null
    },
    showLabel: {
        type: Boolean,
        default: true
    }
})

const email = defineModel()

const enterHandler = (event) => {
    emit('keyup:enter', event);
}
</script>
